import type { ResetPassword } from '@/types/models'
import request from './request'

export const resetPassword = async (params: ResetPassword): Promise<void> => {
  const formData = new FormData()
  formData.append('password', params.password)
  formData.append('repeat_password', params.repeat_password)

  return request.urlencoded(`/reset/${params.hash}`, formData)
}
